export default __webpack_public_path__ + "static/68853-d02a0f7d3d3a6b0ecf227281a2a1cb66.jpg";